import { getText } from "./languages";

export const perCapitaMultiplier = 100 * 1000; // we now are hardcoding 100,000 into translations strings, change this at your peril
export const perCapitaLabelMaker = (value, decimalPlaces = 1, language='en') => {
  if (value === null) {
    return getText(language, 'noData')
  }
  return (value * perCapitaMultiplier).toLocaleString(language, { minimumFractionDigits: decimalPlaces, maximumFractionDigits: decimalPlaces });
}
